import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'dateExtra'
})
export class DateExtraPipe implements PipeTransform {
  transform(value: Date | string): string | null {
    const date = new Date(value);
    const locale = localStorage.getItem("lang") || navigator.language || 'en-US';
    const formatter = new Intl.DateTimeFormat(locale, {
      day: '2-digit',
      month: 'long',
      year: 'numeric'
    });

    return formatter.format(date);
  }
}
